/*----------------------------------
- PHONE BROWSE CHIPS
----------------------------------*/

/**
 * @docs docs/features/website-domains-hubs
 * @adr ADR-0029
 *
 * The hub links the phone shows under the title, where the desktop keeps the filter rail.
 *
 * They are the desktop's own preset catalog, so the two surfaces offer the same entry points
 * and a new preset appears on both at once. Each chip is a plain link to an existing crawlable
 * hub route: nothing here orders, ranks or filters the rows below, so the public listing keeps
 * the engine's neutral order.
 */

/*----------------------------------
- DEPENDANCES
----------------------------------*/

import {
    DOMAINS_POPULAR_FILTER_PRESET_CATALOG,
    getPublicFilterPresetHref,
} from '@/common/catalogs/domains/filterPresets';

/*----------------------------------
- TYPES
----------------------------------*/

export type DomainsBrowseChip = {
    label: string;
    href: string;
};

/*----------------------------------
- BUILDER
----------------------------------*/

/**
 * The preset hubs, minus the one the visitor is already reading.
 *
 * `currentPath` still carries its query string on a filtered search, so only the pathname is
 * compared: `/domains/short?rules=...` is still the Short hub.
 */
export const buildDomainsBrowseChips = (currentPath: string): DomainsBrowseChip[] => {
    const currentPathname = currentPath.split('?')[0]?.replace(/\/+$/, '') || '/domains';

    return DOMAINS_POPULAR_FILTER_PRESET_CATALOG.flatMap((preset) => {
        const href = getPublicFilterPresetHref(preset.presetName);
        return href === currentPathname ? [] : [{ label: preset.label, href }];
    });
};
